
import { atom, createStore } from "jotai";
import { artifactAtom } from "./artifact";
import { sidebarLayoutAtom, SidebarStatus } from "./sidebar";


export const store = createStore();

export const isReplayingAtom = atom(false);

export const startReplayingAtom = atom(null, (_, set) => {
  set(isReplayingAtom, true);
  set(artifactAtom, {
    code: '',
  });
  set(sidebarLayoutAtom, (prev) => ({
    ...prev,
    sidebarStatus: SidebarStatus.Close,
  }));
});


export const toolCallAtom = atom('')

store.sub(isReplayingAtom, () => {
  const isReplaying = store.get(isReplayingAtom);
  document.body.classList.toggle('replaying', isReplaying);
});


